import Sidebar from 'components/commons/sidebar'

export const AwardWinner = ({ options, content, activeSidebar, onChangeSidebar }) => {
    return (
        <div className={'flex space-x-6 px-9 py-4'}>
            <Sidebar
                className={'w-[248px] sticky top-[88px]'}
                title={'Section Order'}
                options={options}
                activeSidebar={activeSidebar}
                onChange={onChangeSidebar}
            />
            <div className={'w-[calc(100%-272px)] overflow-hidden'}>{content[activeSidebar]}</div>
        </div>
    )
}
